export default "__VITE_ASSET__Cq$sxwzk__"